import * as actionTypes from '../Action/Actiontypes';

const initialstate = {
    loading: null,
    error: null,
    guest: {},
    viewguest: [],

}

export const GuestReducer = (state = initialstate, action) => {
    switch (action.type) {
        case actionTypes.ADD_GUEST_INIT:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.ADD_GUEST_SUCCESS:
            return {
                ...state,
                guest: action.payload,
                loading: false
            }
        case actionTypes.ADD_GUEST_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            }

        // -------VIEW GUEST---------------
        case actionTypes.VIEW_GUEST_INIT:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.VIEW_GUEST_SUCCESS:
            // console.log(action.payload)
            return {
                ...state,
                viewguest: action.payload,
                loading: false
            }
        case actionTypes.VIEW_GUEST_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        // -------DELETE GUEST---------------
        case actionTypes.DELETE_GUEST_INIT:
            return {
                ...state,
                loading: true,

            }
        case actionTypes.DELETE_GUEST_SUCCESS:
          
            return {
                ...state,
                loading: false,

            }
        case actionTypes.DELETE_GUEST_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        // -------UPDATE GUEST---------------
        case actionTypes.UPDATE_GUEST_INIT:
            return {
                ...state,
                loading: true,

            }
        case actionTypes.UPDATE_GUEST_SUCCESS:
            return {
                ...state,
                loading: false,
                viewguest: {
                    ...state.viewguest,
                    data: state.viewguest.data.map((guest) =>
                        guest.id === action.payload.id ? action.payload : guest // Update the guest in the list
                    ),
                },
            };

        case actionTypes.UPDATE_GUEST_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        default:
            return state;
    }

}